export const MEDIA_WITH_ICONS = {
  image: {
    source:
      'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2F08cbbc00867c47bda926d914998442c1',
    width: 400,
    height: 344,
  },
  cta: {
    href: 'https://www.serasa.com.br/entrar?product=portal&redirectUrl=%2Farea-cliente%2Fmeu-cpf%2Fvazamentos%2Fconsulta-de-vazamentos',
  },
  icons: [
    {
      id: 1,
      imageSrc:
        'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2F51362d51cc274e3bbbd0cb31ec9c7516',
      label: 'CPF',
    },
    {
      id: 2,
      imageSrc:
        'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2Fa271bed12669496c8ba49b81411ade80',
      label: 'E-mail',
    },
    {
      id: 3,
      imageSrc:
        'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2F9782c81f6a484aa780971741c7b7d7e1',
      label: 'Celular',
    },
  ],
}
